import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarExtraLayer from "../components/CadastrarExtraLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarExtraPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("extra.breadcrumb.create")} />
      <CadastrarExtraLayer />
    </MasterLayout>
  );
};

export default CadastrarExtraPage;
